<template>
  <div>
    <div class="storecard-complete">
      <div class="overlay">
        &nbsp;
      </div>
      <div class="outer">
        <div class="inner">
          <div class="title">
            <h3>Credit Card Successfully Stored</h3>
          </div>
          <div class="card-details">
            <div class="card-name">
              <strong>Name:</strong> {{ cardName }}
            </div>
            <div class="card-pan">
              <strong>Credit Card PAN:</strong> {{ cardPAN }}
            </div>
            <div class="card-type">
              <strong>Card Type:</strong> {{ cardType }}
            </div>
            <div class="expiry-date">
              <strong>Expiry Date:</strong> {{ cardExpDate }}
            </div>
            <div>
              <a href="javascript:window.history.back()">Go Back</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'storecard-complete',
  props: {
    cardDetails: {
      type: Object,
      required: true
    }
  },
  computed: {
    cardName: function() {
      return this.cardDetails.name
    },
    cardPAN: function() {
      return this.cardDetails.pan
    },
    cardType: function() {
      return this.cardDetails.type
    },
    cardExpDate: function() {
      return dayjs(this.cardDetails.expdate).format('MMM YYYY')
    }
  }
}
</script>

<style lang='scss' scoped>

  .storecard-complete .outer {
    position: relative;
    z-index: 15;
    margin: 0 auto;
    max-width:80%;
  }
  .storecard-complete .inner {
    position: absolute;
    background-color: #fff;
    top: 0;
    padding: 2em;
    z-index: 20;
    text-align: center;
    width: 80%;
    border-radius: 3px;
    margin: 2em auto;
    left: 0;
    right: 0;
    box-shadow: 0px 1px 10px 0px #00000040;
  }

  .storecard-complete .overlay {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .4;
    z-index: 10;
    background-color: #EEE;
  }

</style>
